import { MailConfig, PhoneConfig } from 'src/types/widget';

export function hasValidContactInfo(config: {
  contact?: {
    phone?: string;
    email?: string;
  };
  settings?: {
    contactInformation?: Record<string, Array<PhoneConfig | MailConfig>>;
  };
}): boolean {
  // Check if there are direct contact details
  if (config.contact?.phone || config.contact?.email) {
    return true;
  }

  // Check if there are contact information settings
  if (config.settings?.contactInformation) {
    const contactInfo = config.settings.contactInformation;
    // Check if there's a default section
    if (contactInfo.default && contactInfo.default.length > 0) {
      return true;
    }
    // Check other sections
    return Object.values(contactInfo).some((section) => Array.isArray(section) && section.length > 0);
  }

  return false;
}
